module.exports = __webpack_public_path__ + "r-v3/img/ml_81_00_over.ac7c1bea.jpg";